import { FunctionComponent } from 'react';

import Button, {    ButtonElements,
    ButtonLayouts,    ButtonSizes,
    ButtonStyles,
    ButtonTypes,
    ButtonVariants } from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionInstruction: FunctionComponent<Props> = ({
    translations: { boxs },
}) => {
    return (
        <StyledComponent className="public-page-about-section-instruction">
            <LayoutContainer>
                <div className="boxs-wrapper">
                    {boxs.map(box => (
                        <div
                            key={box.title}
                            className="box-wrapper"
                        >
                            <div className="content">
                                <div
                                    className="title"
                                    dangerouslySetInnerHTML={{ __html: box.title }}
                                />
                                <div
                                    className="subtitle"
                                    dangerouslySetInnerHTML={{ __html: box.subtitle }}
                                />
                            </div>
                            <Button
                                type={ButtonTypes.Button}
                                element={ButtonElements.Anchor}
                                href={box.buttonHref}
                                size={ButtonSizes.Medium}
                                style={ButtonStyles.Primary}
                                variant={ButtonVariants.Primary}
                                layout={ButtonLayouts.Wide}
                            >
                                {box.buttonLabel}
                            </Button>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionInstruction;